class CartProductItems extends CartItems {
  cartProductWrapperUnsubscriber = undefined;

  connectedCallback() {
    super.connectedCallback();
    this.cartProductWrapperUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const wrapper = document.querySelector('.cart-product');
      if (wrapper && event.cartData) {
        wrapper.classList.toggle('is-empty', event.cartData.item_count === 0);
      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.cartProductWrapperUnsubscriber) {
      this.cartProductWrapperUnsubscriber();
    }
  }

  onChange(event) {
    if (!event.target?.classList?.contains('quantity__input')) return;
    super.onChange(event);
  }

  onCartUpdate() {
    return fetch(`${routes.cart_url}?section_id=cart-product`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-product-items');
        if (sourceQty) {
          this.innerHTML = sourceQty.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    const sections = [];
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems?.dataset.id) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-cart-items-contents',
      });
    }

    sections.push({
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section',
    });

    if (mainCartFooter?.dataset.id) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.js-checkout-contents',
      });
    }

    if (document.getElementById('CartDrawer')) {
      sections.push({
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      });
    }

    return sections;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) {
      mainCartItems.classList.add('cart-product__items--disabled');
    }

    document.activeElement?.blur();
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart-product__items--disabled');
    }
  }
}

if (!customElements.get('cart-product-items')) {
  customElements.define('cart-product-items', CartProductItems);
}
